import { useState, useEffect } from "react";
import { eventDetailsAPI } from "../../apis/event-details-api";
import {
  fetchDashboardReport,
  fetchGuestListReports
} from '../../apis/guest-list-report-api';
import Reports from "../../components/reports/reports.component";
import LoadingSpinner from '../../components/loading-spinner/loading-spinner.component';
import './event-reports-route.style.scss';
import TicketStatsCard from '../../components/TicketsStats/TicketStatsCard';

const EventDetailsPage = () => {
  const eventObject = JSON.parse(sessionStorage.getItem('eventObject'));
  const [reportsData, setReportsData] = useState({});
  const [guestListReport, setGuestListReport] = useState({});
  const [reportExcelData, setReportExcelData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const token = localStorage.getItem('token');

  const fetchReportsData = async () => {
    try {
      const data = await eventDetailsAPI(eventObject.id, token);
      setReportsData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataAndGenerateExcel = async () => {
    try {
      setIsDownloading(true);
      const data = await fetchGuestListReports(token, eventObject.id);
      alert('Report has been sent to the admin email');
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const getDashboardReport = async () => {
    try {
      setIsDownloading(true);
      const data = await fetchDashboardReport(token, eventObject.id);
      setGuestListReport(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    fetchReportsData();
    getDashboardReport();
  }, []);

  // const stringToArrayBuffer = (s) => {
  //   const buf = new ArrayBuffer(s.length);
  //   const view = new Uint8Array(buf);
  //   for (let i = 0; i < s.length; i++) {
  //     view[i] = s.charCodeAt(i) & 0xff;
  //   }
  //   return buf;
  // };

  if (!reportsData) {
    return (
      <div className="event-reports-container">
        <p className="reports-error-message">
          An Unexpected Error Occured while fetching reports data. Please try
          Again!
        </p>
      </div>
    );
  }

  return (
    <div className="event-reports-container">
      <div className="report-logo-container">
        <img
          src={eventObject.imageUrl}
          className="report-logo"
          alt="event-pic"
        ></img>
      </div>

      <div className="report-name-container">
        <h1 className="report-name">{eventObject.eventName} </h1>
      </div>

      {
        <TicketStatsCard
          reduceToBePaidCount={guestListReport?.reduceToBePaid}
          paidReduceCount={guestListReport?.paidReduce}
          fullToBePaidCount={guestListReport?.fullToBePaid}
          paidFullCount={guestListReport?.paidFull}
          compCount={guestListReport?.comp}
          prepaidCount={guestListReport?.prepaid}
          paidReduceRevenue={guestListReport?.paidReduceRevenue ?? 0}
          paidFullRevenue={guestListReport?.paidFullRevenue ?? 0}
          prepaidRevenue={guestListReport?.prepaidRevenue ?? 0}
          totalRevenue={
            (guestListReport?.paidReduceRevenue ?? 0) +
            (guestListReport?.paidFullRevenue ?? 0) +
            (guestListReport?.prepaidRevenue ?? 0)
          }
          onDownloadPressed={() => {
            fetchDataAndGenerateExcel();
          }}
          isDownloading={isDownloading}
        />
      }
      {isLoading ? <LoadingSpinner /> : <Reports reportsData={reportsData} />}
    </div>
  );
};

export default EventDetailsPage;
